<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <article class="title-section form-section">
            <h1 class="page-title text-center">Apply Now!</h1>
            <p class="page-desc text-center">Real Estate Appraisers Errors & Omissions Insurance {{ currentRouteName }}</p>
            <img
              src="../../../public/assets/images/calc.png"
              class="title-section-img"
              alt="background image"
            >
          </article>
          <article class="input-section d-flex flex-column align-items-center pt-0 form-section">
            <p class="text-center">
              This policy applies only to claims first made against the insured during the policy period or discovery period. The limit of liability available to pay judgements or settlements shall be reduced by payment of defense costs. Defense costs are subject to the applicable retention. Please read and review the policy carefully.
            </p>
            <div class="d-flex">
              <i class="legalese-fa fas fa-info-circle"></i>
              <div class="d-flex flex-column">
                <p class="more-desc-p pr-0 pl-0 text-center flex">
                  Instructions: This application is for an individual who only does 100% Real Estate Appraisal work.
                  NOTE: Coverage only applies to services rendered by the applicant.
                </p>
                <p class="font-weight-bold">
                  The term "Applicant" shall mean all natural persons proposed for coverage.
                </p>
              </div>
            </div>
          </article>
          <form action @submit.prevent="next">
            <article class="form-heading title-section form-section row mr-0 ml-0 special-header">
              <h2 class="form-title col-md-4 pl-5 mr-0 ml-0">Personal</h2>
              <p class="col-md-4 col-sm-12">
                Enter the name of the individually licensed applicant along with a business name (if any) and provide a street address for your business (alternate mailing address such as a PO Box and administrative contacts should be provided in the space indicated below).​​​​​​​
              </p>
              <img
                src="../../../public/assets/images/glasses.png"
                style="top:29px"
                class="title-section-img form-title-img col-md-4"
                alt="background image"
              >
            </article>
            <article class="input-section form-section">
              <label for class="orep-label">
                <span class="font-weight-bold" style="text-decoration: underline;">
                Section A. General Information
                </span>
              </label>
              <div class="pt-0" >
                <div class="row pb-3">
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Name of Appraiser:
                    </label>
                    <input
                      type="text"
                      name="fullLegalNameOfAppraiser"
                      v-model="axApplication.fullLegalNameOfAppraiser"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      :disabled="state.fullLegalNameOfAppraiserValid"
                    >
                    <span
                      v-show="errors.has('fullLegalNameOfAppraiser')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('fullLegalNameOfAppraiser') | filterText }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Name of Firm You Operate Under (as Owner or Staff Appraiser):
                    </label>
                    <input
                      type="text"
                      name="firmNameOfAppraiser"
                      v-model="axApplication.firmNameOfAppraiser"
                      class="orep-text-input w-100"
                    >
                  </div>
                </div>
                <div class="row pb-3">
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Principal Street Address:
                    </label>
                    <input
                      type="text"
                      name="address"
                      v-model="axApplication.customer.address"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('address')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('address') | filterText }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      City:
                    </label>
                    <input
                      type="text"
                      name="city"
                      v-model="axApplication.customer.city"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('city')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('city') | filterText }}</span>
                  </div>
                </div>
                <div class="row pb-3">
                  <div class="col-md-4">
                    <label for class="orep-label mb-0 ml-1">
                      State:
                    </label>
                    <select
                      class="orep-select w-100"
                      style="height: 40px; width: 383px;"
                      name="state"
                      v-model="axApplication.customer.state"
                      v-validate="'required'"
                      @change="validateBeforeSubmit()"
                    >
                      <option v-for="(item, key) in states" :value="key">
                        {{item}}
                      </option>
                    </select>
                    <span
                      v-show="errors.has('state')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('state') | filterText }}</span>
                  </div>
                  <div class="col-md-4">
                    <label for class="orep-label mb-0 ml-1">
                      ZIP Code:
                    </label>
                    <input
                      type="text"
                      name="zipCode"
                      v-model="axApplication.customer.zipCode"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('zipCode')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('zipCode') | filterText }}</span>
                  </div>
                  <div class="col-md-4">
                    <label for class="orep-label mb-0 ml-1">
                      County:
                    </label>
                    <input
                      type="text"
                      name="county"
                      v-model="axApplication.customer.county"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('county')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('county') | filterText }}</span>
                  </div>
                </div>
                <div class="radio orep-radio-wrapper solo-checkbox" style="padding-top: 10px">
                  <label class="orep-label ml-1">
                    <input
                        type="checkbox"
                        name="checkIfMailAddressSame"
                        class="orep-radio w-40"
                        v-model="axApplication.checkIfMailAddressSame"
                    >
                    <span class="radio-span solo-checkbox-span" style="color: #046085">
                    Check this box if Mailing Address is the same
                  </span>
                  </label>
                </div>
                <div class="row pb-3">
                  <div class="col-md-12">
                    <label for class="orep-label mb-0 ml-1">
                      Mailing Address:
                    </label>
                    <input
                      type="text"
                      name="mailingAddress"
                      v-model="axApplication.mailingAddress"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('mailingAddress')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('mailingAddress') | filterText }}</span>
                  </div>
                </div>

                <div class="row pb-3">
                  <div class="col-md-4">
                    <label for class="orep-label mb-0">
                      <span class="qtn mrpx-5"></span>Phone:
                    </label>
                    <input
                      type="text"
                      name="phone"
                      v-model="axApplication.customer.phone"
                      class="orep-text-input w-100"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('phone')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('phone') | filterText }}</span>
                  </div>
                  <div class="col-md-4">
                    <label for class="orep-label mb-0">
                      <span class="qtn mrpx-5"></span>Fax:
                    </label>
                    <input
                      type="text"
                      name="fax"
                      v-model="axApplication.customer.fax"
                      class="orep-text-input w-100"
                    >
                  </div>
                  <div class="col-md-4">
                    <label for class="orep-label mb-0">
                      <span class="mr-1"></span>Email:
                    </label>
                    <input
                      type="email"
                      name="email"
                      autocomplete="email"
                      v-model="axApplication.customer.email"
                      class="orep-text-input w-100"
                      v-validate="'required|email'"
                      @input="validateBeforeSubmit()"
                    >
                    <span
                      v-show="errors.has('email')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('email') | filterText }}</span>
                  </div>

                </div>
                <div class="row">
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Desired Effective Date:
                    </label>
                    <datepicker
                      name="effectiveDate"
                      v-model="axApplication.effectiveDate"
                      v-validate="'required'"
                      format="MM/dd/yyyy"
                      input-class="orep-text-input col-md-12"
                      @input="validateBeforeSubmit()"
                      :disabled="state.effectiveDateValid"
                      :clearButton="false"
                      :value="computedDates"
                    ></datepicker>
                    <span
                      v-show="errors.has('effectiveDate')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('effectiveDate') | filterText }}</span>
                  </div>
                  <div class="col-md-6">
                    <label for class="orep-label mb-0 ml-1">
                      Retroactive Date:
                    </label>
                    <datepicker
                      name="retroactiveDate"
                      v-model="axApplication.retroactiveDate"
                      format="MM/dd/yyyy"
                      input-class="orep-text-input col-md-12"
                      :disabled="state.retroactiveDateValid"
                      :clearButton="false"
                      :value="computedDates"
                    ></datepicker>

                  </div>
                </div>
                <div class="row pb-3">
                  <div class="col-md-6 ">
                    <span>We cannot backdate coverage.</span>
                  </div>
                  <div class="col-md-6">
                    <span>
                      If you have current coverage, but don't know your Retroactive Date, please leave blank.
                    </span>
                  </div>
                </div>
                <div v-if="getApplicantType === 'OREP'" class="col mt-1 small">
                  <p class="input-info">
                    <i class="fas fa-exclamation-triangle not-eligible"></i><span class="not-eligible-text">
                  If you are new to OREP, please email a copy of your Expiring Declarations Page to
                   <strong><a href="mailto:appraisers@orep.org" target="_top">appraisers@orep.org</a></strong>
                </span>
                  </p>
                </div>
              </div>
              <div  v-if="!this.state.signedInUser">
                <div class="row">
                  <div class="col-md-9 col-sm-12">
                    <label for class="orep-label">
                      Do you have an active E&O policy of your own that is currently in force?                   </label>
                  </div>
                  <div class="col-md-3 d-flex flex-column justify-content-center">
                    <div class="d-flex flex-row">
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="noPriorCoverage"
                            :value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="axApplication.noPriorCoverage"
                          >
                          <span class="radio-span">Yes</span>
                        </label>
                      </div>
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="noPriorCoverage"
                            :value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="axApplication.noPriorCoverage"
                          >
                          <span class="radio-span">No</span>
                        </label>
                      </div>
                    </div>
                    <span
                      v-show="errors.has('noPriorCoverage')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('noPriorCoverage') | filterText }}</span>
                  </div>
                </div>
              </div>
              <div class="">
                <div class="row">
                  <div class="col-md-9 col-sm-12">
                    <label for class="orep-label">
                      Are you A Member of a Professional Association?                   </label>
                  </div>
                  <div class="col-md-3 d-flex flex-column justify-content-center">
                    <div class="d-flex flex-row">
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="professionalAssociation"
                            :value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="axApplication.professionalAssociation"
                          >
                          <span class="radio-span">Yes</span>
                        </label>
                      </div>
                      <div class="radio orep-radio-wrapper">
                        <label>
                          <input
                            type="radio"
                            name="professionalAssociation"
                            :value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="axApplication.professionalAssociation"
                          >
                          <span class="radio-span">No</span>
                        </label>
                      </div>
                    </div>
                    <span
                      v-show="errors.has('professionalAssociation')"
                      class="help is-danger form-errors text-danger"
                    >{{ errors.first('professionalAssociation') | filterText }}</span>
                  </div>
                </div>
                <div class="flex wrap">
                  <div class="d-flex w-100">
                    <div class="col-md-9">
                <input
                    type="text"
                    class="orep-text-input js-orep-input"
                    placeholder="Please List the Association:"
                    v-if="axApplication.professionalAssociation === 'true' || axApplication.professionalAssociation == true"
                    name="professionalAssociationDetails"
                    v-model="axApplication.professionalAssociationDetails"
                >
                    </div>
                  </div>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="radio orep-radio-wrapper solo-checkbox" style="padding-bottom: 25px">
                <label>
                  <input
                    type="checkbox"
                    name="emailPolicy"
                    class="orep-radio w-40"
                    v-model="axApplication.emailPolicy"
                  >
                  <span class="radio-span solo-checkbox-span">
                    In lieu of mailing my policy, please Email my policy to the above address. I agree to accept an electronic copy of my application with my policy.
                  </span>
                </label>
              </div>
              <label v-if="getApplicantType === 'OREP'"  for class="orep-label">
                <i class="fas fa-exclamation-triangle not-eligible"></i><span>
                  If you have a policy in force, you will need prior acts coverage. Attach a copy of your current Declarations page
showing the prior acts date.
                </span>
              </label>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <article class="orep-pagination">
              <button class="pagination-dots pagination-current"></button>
              <button
                class="pagination-dots"
                @click="navigateToNext('ax-application-2')"
                :disabled="!state.pageOneIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('ax-application-3')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('ax-application-4')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('ax-application-5')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('ax-application-6')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid">
              </button>
            </article>
<!--            <button type="submit" :disabled="!state.pageOneIsValid"-->
<!--                    :class="{submitDisabled: !state.pageOneIsValid}" class="next-btn mont spaced pull-right" @click="navigateToNext('ax-application-extra-page')"-->
<!--            v-if="axApplication.customer.state === 'NH' || axApplication.customer.state === 'IL' || axApplication.customer.state === 'MT' || axApplication.customer.state ==='VA'">Next</button>-->

            <button type="submit" :disabled="!state.pageOneIsValid"
              :class="{submitDisabled: !state.pageOneIsValid}" class="next-btn mont spaced pull-right" @click="pageOneSubmit('ax-application-2')">Next</button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Datepicker from 'vuejs-datepicker';
import {APP_STATUS, STATES, STATUS} from "../../utils/constants";
var moment = require('moment')

export default {
  name: "ax-application-1",
  computedDates () {
    return moment(this.value).format('YYYY-MM-D')
  },
  data() {
    return {
      states: STATES
    };
  },
  computed: {

    axApplication() {
      return this.$store.state.axApplication.axApplication;
    },
    state() {
      return this.$store.state.axApplication;
    },
    errorMsg() {
      return this.$store.state.axApplication.errorMsg;
    },
    getApplicantType() {
      var route = this.$route.path;
      var first = route.substring(0, route.lastIndexOf("/") + 1);
      if (first === '/portal/ax-application-amba' || first === '/portal/ax-application-amba/' || this.axApplication.customer.partnerName === 'Mercer'){
        return 'Mercer';
      }else if (first === '/portal/ax-application-realshield' || first === '/portal/ax-application-realshield/' || this.axApplication.customer.partnerName === 'Realshield'){
        return 'Realshield';
      }else {
        return 'OREP';
      }
    },
  },


  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    },

    'axApplication.checkIfMailAddressSame'(newVal) {
      if (newVal) {
        this.axApplication.mailingAddress = this.axApplication.customer.address;
      } else {
        this.axApplication.mailingAddress = '';
      }
    },
    'axApplication.customer.address'(newAddress) {
      if (this.axApplication.checkIfMailAddressSame) {
        this.axApplication.mailingAddress = newAddress;
      }
    }
  },

  methods: {

    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    pageOneSubmit(routeName) {
      this.loading = true;
      this.axApplication.customer.contactName = this.state.axApplication.fullLegalNameOfAppraiser;
      this.axApplication.customer.companyName = this.state.axApplication.firmNameOfAppraiser;
      this.axApplication.customer.isAxApplication = 'True';
      this.axApplication.customer.appStatus = APP_STATUS.Partially_Completed;
      if (this.getApplicantType === 'Mercer'){
        this.axApplication.customer.partnerName = 'Mercer';
      }
      else if (this.getApplicantType === 'Realshield') {
        this.axApplication.customer.partnerName = 'Realshield';
      }
      this.$store.dispatch('axApplication/createCustomer');


      // this.$router.push({
      //   name: routeName,
      // });
    },

    navigateToNextCustomLink() {
      window.open("https://orep.org/wp-content/uploads/2019/09/IL_NH_MT-Individual-Appraiser-Application.pdf", "_blank");
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageOneIsValid = true;
          return;
        }
        this.state.pageOneIsValid = false;
      });
    }
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    const params = this.$route.query;
    if (params && params.filter) {
      this.state.axApplication.applicantRequestFrom = params.filter;
    }
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
  },

  components: {
    Datepicker
  }
};
</script>

<style scoped>
  .page-desc {
    width: 295px;
    height: 45px;
  }
  .form-title {
    font-size: 35px !important;
  }
  .w-40 {
    flex: 0 0 40px;
  }
</style>
